import React, { useEffect, useRef, useState } from 'react';
import PdfService from '../../../services/pdfService.js';
import { Document, Page } from 'react-pdf';
import { pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/TextLayer.css';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import styles from './CampaignEffectMeasure.module.css';

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
    'pdfjs-dist/build/pdf.worker.min.mjs',
    import.meta.url,
).toString();

const CampaignEffectMeasure = (props) => {
    const containerRef = useRef();
    const [containerHeight, setContainerHeight] = useState(window.innerHeight - 225);
    const [pdfData, setPdfData] = useState(null);
    const [fileName, setFileName] = useState(null);
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);

    useEffect(() => {
        const fetchPDFData = async () => {
            try {
                const blobData = await PdfService.getFileData(props.selectedOrderlineMetaData[0].id);
                setPdfData(blobData.url);
            } catch (error) {
                console.error("Error fetching PDF data:", error);
            }
        };

        fetchPDFData();
    }, []);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'ArrowLeft' && pageNumber > 1) {
                setPageNumber(pageNumber - 1);
            } else if (event.key === 'ArrowRight' && pageNumber < (numPages || 0)) {
                setPageNumber(pageNumber + 1);
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [pageNumber, numPages]);

    const onLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
    };

    const handleDownload = () => {
        const link = document.createElement('a');
        link.href = pdfData;
        link.download = `${fileName}.pdf`;
        link.click();
    };

    useEffect(() => {
        const updateHeight = () => {
            setContainerHeight(window.innerHeight -225);
        };

        updateHeight();
        window.addEventListener('resize', updateHeight);
        return () => window.removeEventListener('resize', updateHeight);
    }, []);

    return (
        <div className={styles.wrapper}>
            {pdfData ? (
                <>
                    <div className={styles.pdfArea}>
                        <button
                            className={`${styles.sideButton} ${styles.leftButton}`}
                            disabled={pageNumber <= 1}
                            onClick={() => setPageNumber(pageNumber - 1)}
                        >
                            &lt;
                        </button>

                        <div className={styles.pdfContainer}>
                            <Document
                                file={pdfData}
                                onLoadSuccess={onLoadSuccess}
                                loading={<div className={styles.loading}>Loading PDF...</div>}
                                error={<div className={styles.error}>Failed to load PDF</div>}
                            >
                                <Page pageNumber={pageNumber} height={containerHeight} />
                            </Document>
                        </div>

                        <button
                            className={`${styles.sideButton} ${styles.rightButton}`}
                            disabled={pageNumber >= numPages}
                            onClick={() => setPageNumber(pageNumber + 1)}
                        >
                            &gt;
                        </button>
                    </div>

                    <span className={styles.pageInfo}>{`Page ${pageNumber} of ${numPages}`}</span>
                </>
            ) : (
                <p>Loading PDF...</p>
            )}
        </div>
    );
};

export default CampaignEffectMeasure;